import DocumentationButton from './DocumentationButton';

export default DocumentationButton;
export * from './types';
export { DocumentationButton };
